// assets
import { IconDashboard, IconClipboardList } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconClipboardList };
const envType = process.env.REACT_APP_ENV_TYPE ? ` [${process.env.REACT_APP_ENV_TYPE}]` : '';

// ==============================|| DASHBOARD MENU ITEMS 1st ||============================== //

const menuHearingAid = {
  id: 'dashboard1',
  title: '메뉴 - 모두의 보청기' + envType,
  type: 'group',
  children: [
    {
      id: 'user-management',
      title: '사용자 관리',
      type: 'collapse',
      icon: icons.IconClipboardList,
      children: [
        {
          id: 'users',
          title: '사용자 관리',
          type: 'item',
          url: '/users',
          //icon: icons.IconClipboardList,
          breadcrumbs: false
        },
        {
          id: 'hearingCertifications',
          title: '청각 등록증 관리',
          type: 'item',
          url: '/hearing-certifications',
          //icon: icons.IconClipboardList,
          breadcrumbs: false
        },
      ],
    },
    {
        id: 'banners',
        title: '배너 관리',
        type: 'item',
        url: '/banners',
        icon: icons.IconClipboardList,
        breadcrumbs: false
    },
    {
      id: 'content-management',
      title: '컨텐츠 관리',
      type: 'collapse',
      icon: icons.IconClipboardList,
      children: [
        {
          id: 'communitys',
          title: '커뮤니티 게시글 관리',
          type: 'item',
          url: '/communitys',
          breadcrumbs: false
        },
        {
          id: 'comments',
          title: '커뮤니티 댓글 관리',
          type: 'item',
          url: '/comments',
          breadcrumbs: false
        },
        {
          id: 'customerCenters',
          title: '고객센터 관리',
          type: 'item',
          url: '/customer-centers',
          breadcrumbs: false
        },    
        {
          id: 'kiosk-data-rooms',
          title: '자료실 관리 (Original)',
          type: 'item',
          url: '/kiosk-data-rooms',
          // icon: icons.IconClipboardList,
          breadcrumbs: false
        },
        {
          id: 'dataRoomsNew',
          title: '자료실 관리 (New)',
          type: 'item',
          url: '/data-rooms-new',
          breadcrumbs: false
        },
        {
          id: 'newsLetters',
          title: '보청기 소식 관리',
          type: 'item',
          url: '/news-letters',
          breadcrumbs: false
        },
      /*{
        id: 'excelDatas',
        title: 'ExcelData 관리',
        type: 'item',
        url: '/excel-datas',
        //icon: icons.IconClipboardList,
        breadcrumbs: false
      },*/
       ]
    },
    {
      id: 'place-management',
      title: '업체 관리',
      type: 'collapse',
      icon: icons.IconClipboardList,
      children: [
        {
          id: 'places',
          title: '업체 정보 관리',
          type: 'item',
          url: '/places',
          //icon: icons.IconClipboardList,
          breadcrumbs: false
        },
        {
          id: 'placeReviews',
          title: '업체 리뷰 관리',
          type: 'item',
          url: '/reviews',
          //icon: icons.IconClipboardList,
          breadcrumbs: false
        },
        {
          id: 'requests',
          title: '업체 수정 요청 관리',
          type: 'item',
          url: '/requests',
          //icon: icons.IconClipboardList,
          breadcrumbs: false
        },
      ]
    },
    {
      id: 'result-management',
      title: '검사정보 관리',
      type: 'collapse',
      icon: icons.IconClipboardList,
      children: [
        {
          id: 'surveys',
          title: '설문검사 결과 관리',
          type: 'item',
          url: '/surveys',
          breadcrumbs: false
        },
        {
          id: 'hearingTests',
          title: '청력검사 결과 관리',
          type: 'item',
          url: '/hear-tests',
          breadcrumbs: false
        },
        {
          id: 'noiseTest',
          title: '소음하청력 결과 관리',
          type: 'item',
          url: '/noise-test',
          breadcrumbs: false
        },
        {
          id: 'expertFeedbacks',
          title: '전문가 피드백 관리',
          type: 'item',
          url: '/expert-feedbacks',
          breadcrumbs: false
        },
      ]
    },
    {
      id: 'reports',
      title: '신고 관리',
      type: 'item',
      url: '/reports',
      icon: icons.IconClipboardList,
      breadcrumbs: false
    },
  ]
};




export default menuHearingAid;
